import styled from 'styled-components';

const Container = styled.div`
  display: grid;
  align-items: start;
  column-gap: 10px;
  @media (min-width: 992px) {
    grid-template-columns: 0.5fr 1fr;
  }
`;
const ShippingPricing = styled.div`
  min-height: 150px;
  box-shadow: 4px 4px 10px #d9d9d9, -4px -4px 10px #ffffff;
  border-radius: 5px;
  background-color: #fff;

  > h1 {
    display: flex;
    align-items: center;
    letter-spacing: 1px;
    color: #6d6e71;
    font-weight: 600;
    padding: 10px 15px;
    margin: 0;
    font-size: 13px;
  }
  > div {
    display: grid;
    justify-items: center;
    padding: 15px;
    p {
      margin: 0;
    }
    > div {
      display: grid;
      grid-template-columns: repeat(auto-fit, minmax(200px, 0.3fr));
      column-gap: 10px;
      min-height: 240px;
      justify-content: center;
      flex-wrap: wrap;
      margin-top: 12.5px;
      flex-direction: column;
      width: 100%;
      text-align: center;

      img {
        max-width: 100%;
        height: auto;
        transition: border ease-out 0.25s;
        border-radius: 4px;
        border: 2px solid #c7c8c9;
        box-sizing: border-box;
        border: 2px solid #3b3b3d;
        cursor: pointer;
      }
      h5 {
        font-size: 19px;
        margin: 19px auto;
        color: #3b3b3d;
      }
      @media (min-width: 992px) {
        flex-direction: row;
      }
    }
  }
`;

export { Container, ShippingPricing };
